export type ManagementSportConfig = {
  label: string;
  value: string;
  icon?: string;
};

export function normalizeSportValue(sport: string): string {
  const normalized = sport.trim().toLowerCase().replace(/\s+/g, '-');
  if (normalized === 'swimming') {
    return 'swim';
  }
  if (normalized === 'padel') {
    return 'paddle';
  }

  return normalized;
}

export function getSportConfig<T extends ManagementSportConfig>(sport: string, configs: T[]): T {
  const trimmedSport = sport.trim();
  const value = normalizeSportValue(trimmedSport);
  return configs.find(config =>
    config.value === trimmedSport ||
    normalizeSportValue(config.value) === value ||
    normalizeSportValue(config.label) === value ||
    (!!config.icon && (config.icon === trimmedSport || normalizeSportValue(config.icon) === value))
  ) ?? configs[0] ?? ({ label: sport, value } as T);
}

export function getSportIconPath(sport: string, configs?: ManagementSportConfig[]): string {
  const config = configs?.length ? getSportConfig(sport, configs) : null;
  const value = config?.icon || (config ? normalizeSportValue(config.label) : normalizeSportValue(sport));
  return `assets/icons/sport/${value}.svg`;
}

export function getSportOptionValue(sport: string, configs?: ManagementSportConfig[]): string {
  return configs?.length ? getSportConfig(sport, configs).value : normalizeSportValue(sport);
}

export function getSportLabelFromValue(value: string, configs: ManagementSportConfig[]): string {
  return getSportConfig(value, configs).label;
}
